import type { UserManual } from "types/SupportMaterial";

export const USER_MANUAL_LINKS: UserManual[] = [
  {
    category_id: 1,
    category_en: "イロドキのはじめ方",
    category_ja: "イロドキのはじめ方",
    paragraph_number: "■",
    title_en: "イロドキ導入チェックリスト",
    title_ja: "イロドキ導入チェックリスト",
    url: "https://drive.google.com/file/d/1A0_4dqMivWRQpAswBrOoGYlVbshzbGqZ/view?usp=drive_link",
  },
  {
    category_id: 1,
    category_en: "イロドキのはじめ方",
    category_ja: "イロドキのはじめ方",
    paragraph_number: "■",
    title_en: "【全文】イロドキのはじめ方",
    title_ja: "【全文】イロドキのはじめ方",
    url: "https://drive.google.com/file/d/17BVabD4Wo-AZbGgf5tgv4BkoOh_3NKx7/view?usp=drive_link",
  },
  {
    category_id: 1,
    category_en: "イロドキのはじめ方",
    category_ja: "イロドキのはじめ方",
    paragraph_number: "1",
    title_en: "施設管理画面にログイン",
    title_ja: "施設管理画面にログイン",
    url: "https://drive.google.com/file/d/10WNx7xWSZaOY_NH4TJ4l3IUZaRpKS3cW/view?usp=drive_link",
  },
  {
    category_id: 1,
    category_en: "イロドキのはじめ方",
    category_ja: "イロドキのはじめ方",
    paragraph_number: "2",
    title_en: "クラス・園児登録",
    title_ja: "クラス・園児登録",
    url: "https://drive.google.com/file/d/1hO-1g46W1lUR_SrVzcjIctI_hyuXYYZm/view?usp=drive_link",
  },
  {
    category_id: 1,
    category_en: "イロドキのはじめ方",
    category_ja: "イロドキのはじめ方",
    paragraph_number: "3",
    title_en: "AI用顔登録",
    title_ja: "AI用顔登録",
    url: "https://drive.google.com/file/d/1AN3xHWh3qLTPaY1iku7lzMbI2_1w958T/view?usp=drive_link",
  },
  {
    category_id: 1,
    category_en: "イロドキのはじめ方",
    category_ja: "イロドキのはじめ方",
    paragraph_number: "4",
    title_en: "保護者への案内",
    title_ja: "保護者への案内",
    url: "https://drive.google.com/file/d/13pBb9AcYslbcJknHOuS8C4jU1QBDivDy/view?usp=drive_link",
  },
  {
    category_id: 1,
    category_en: "イロドキのはじめ方",
    category_ja: "イロドキのはじめ方",
    paragraph_number: "5",
    title_en: "カメラアプリの利用登録",
    title_ja: "カメラアプリの利用登録",
    url: "https://drive.google.com/file/d/1sSXEO_DyRkOvJj7vJ32Oc21_u2W-4n8I/view?usp=drive_link",
  },
  {
    category_id: 2,
    category_en: "年度途中の入園・退園",
    category_ja: "年度途中の入園・退園",
    paragraph_number: "■",
    title_en: "【全文】年度途中の入退園",
    title_ja: "【全文】年度途中の入退園",
    url: "https://drive.google.com/file/d/13vqdrhmE4B-Jy81-yYtm8QhTiXm07vpj/view?usp=drive_link",
  },
  {
    category_id: 2,
    category_en: "年度途中の入園・退園",
    category_ja: "年度途中の入園・退園",
    paragraph_number: "1",
    title_en: "途中入園児の対応",
    title_ja: "途中入園児の対応",
    url: "https://drive.google.com/file/d/1Ol27qOaAxQ8SmbROT9PpfVjhPlcZTOv4/view?usp=drive_link",
  },
  {
    category_id: 2,
    category_en: "年度途中の入園・退園",
    category_ja: "年度途中の入園・退園",
    paragraph_number: "2",
    title_en: "途中退園児の対応",
    title_ja: "途中退園児の対応",
    url: "https://drive.google.com/file/d/14plijWBMp6PiFOZ5YOpVy9cvdSDZZpEX/view?usp=drive_link",
  },
  {
    category_id: 3,
    category_en: "新年度準備",
    category_ja: "新年度準備",
    paragraph_number: "■",
    title_en: "【全文】新年度準備",
    title_ja: "【全文】新年度準備",
    url: "https://drive.google.com/file/d/1_GzfRyFPjROUbeHGMm2A92I4mw9PKHFn/view?usp=drive_link",
  },
  {
    category_id: 3,
    category_en: "新年度準備",
    category_ja: "新年度準備",
    paragraph_number: "0",
    title_en: "【必ずご確認ください】新年度準備について",
    title_ja: "【必ずご確認ください】新年度準備について",
    url: "https://drive.google.com/file/d/1lEaVU52eJe6LDlXdNJNWQDnAaa0DfuiM/view?usp=drive_link",
  },
  {
    category_id: 3,
    category_en: "新年度準備",
    category_ja: "新年度準備",
    paragraph_number: "1",
    title_en: "卒園",
    title_ja: "卒園",
    url: "https://drive.google.com/file/d/1LH42IxJwfhlf2SN4wHDe6-BDyM3RNp01/view?usp=drive_link",
  },
  {
    category_id: 3,
    category_en: "新年度準備",
    category_ja: "新年度準備",
    paragraph_number: "2",
    title_en: "進級",
    title_ja: "進級",
    url: "https://drive.google.com/file/d/1hXnIoy1I0olvu-AjKqyLjvXfCnqRcN-d/view?usp=drive_link",
  },
  {
    category_id: 3,
    category_en: "新年度準備",
    category_ja: "新年度準備",
    paragraph_number: "3",
    title_en: "入園",
    title_ja: "入園",
    url: "https://drive.google.com/file/d/1KA051vzXPUtDZOsnKV7ykj6wLYmaM0s8/view?usp=drive_link",
  },
  {
    category_id: 3,
    category_en: "新年度準備",
    category_ja: "新年度準備",
    paragraph_number: "4",
    title_en: "先生アカウントの更新",
    title_ja: "先生アカウントの更新",
    url: "https://drive.google.com/file/d/1PaK7ITti0lhmTQ4RQ5ggiuMmBX6igGRK/view?usp=drive_link",
  },
  {
    category_id: 4,
    category_en: "アカウント設定",
    category_ja: "アカウント設定",
    paragraph_number: "■",
    title_en: "施設情報",
    title_ja: "施設情報",
    url: "https://drive.google.com/file/d/1YiNFoArPBgR8eXrbcF2FU6LS-gLFth3N/view?usp=drive_link",
  },
  {
    category_id: 4,
    category_en: "アカウント設定",
    category_ja: "アカウント設定",
    paragraph_number: "■",
    title_en: "アカウント管理",
    title_ja: "アカウント管理",
    url: "https://drive.google.com/file/d/1bMqENreOXUdqvc_frPDzEfU1pQTYxjhX/view?usp=drive_link",
  },
  {
    category_id: 5,
    category_en: "カメラアプリの使い方",
    category_ja: "カメラアプリの使い方",
    paragraph_number: "■",
    title_en: "カメラアプリの利用登録",
    title_ja: "カメラアプリの利用登録",
    url: "https://drive.google.com/file/d/140pxODtFpS7-gaxsBR8P8p6iOnjd3pN1/view?usp=drive_link",
  },
  {
    category_id: 5,
    category_en: "カメラアプリの使い方",
    category_ja: "カメラアプリの使い方",
    paragraph_number: "■",
    title_en: "【全文】カメラアプリの使い方",
    title_ja: "【全文】カメラアプリの使い方",
    url: "https://drive.google.com/file/d/114iTW3Lz1rRvhBSYyWTckYhqUtD2-n5A/view?usp=drive_link",
  },
  {
    category_id: 5,
    category_en: "カメラアプリの使い方",
    category_ja: "カメラアプリの使い方",
    paragraph_number: "1",
    title_en: "操作画面の説明",
    title_ja: "操作画面の説明",
    url: "https://drive.google.com/file/d/1xvTh5pwg5yhDMa-Q_kVP6CvFPSnJyxMG/view?usp=drive_link",
  },
  {
    category_id: 5,
    category_en: "カメラアプリの使い方",
    category_ja: "カメラアプリの使い方",
    paragraph_number: "2",
    title_en: "撮影クラスの変更方法",
    title_ja: "撮影クラスの変更方法",
    url: "https://drive.google.com/file/d/1r3Ft8IbwB94Dwf4146RoMoLyOXSmEUSa/view?usp=drive_link",
  },
  {
    category_id: 5,
    category_en: "カメラアプリの使い方",
    category_ja: "カメラアプリの使い方",
    paragraph_number: "3",
    title_en: "クラス全体写真の撮影",
    title_ja: "クラス全体写真の撮影",
    url: "https://drive.google.com/file/d/1wHwkBgP3ZR7P_tZrc67hR3QPZicXZUtD/view?usp=drive_link",
  },
  {
    category_id: 5,
    category_en: "カメラアプリの使い方",
    category_ja: "カメラアプリの使い方",
    paragraph_number: "4",
    title_en: "アップロード設定の変更",
    title_ja: "アップロード設定の変更",
    url: "https://drive.google.com/file/d/1-KcXhUN7ON2QmDwWmQyzJrKFDKUGxhyI/view?usp=drive_link",
  },
  {
    category_id: 5,
    category_en: "カメラアプリの使い方",
    category_ja: "カメラアプリの使い方",
    paragraph_number: "5",
    title_en: "未アップロード写真の確認",
    title_ja: "未アップロード写真の確認",
    url: "https://drive.google.com/file/d/1QAeDBNFOEcquBi9HxtqdfVtXmfo1Fwzx/view?usp=drive_link",
  },
  {
    category_id: 6,
    category_en: "写真の配信方法",
    category_ja: "写真の配信方法",
    paragraph_number: "■",
    title_en: "【全文】写真の配信方法",
    title_ja: "【全文】写真の配信方法",
    url: "https://drive.google.com/file/d/1oqiioVQ1-YzUVFLcvwutzrrrBl2EjmqA/view?usp=drive_link",
  },
  {
    category_id: 6,
    category_en: "写真の配信方法",
    category_ja: "写真の配信方法",
    paragraph_number: "1",
    title_en: "アップロード",
    title_ja: "アップロード",
    url: "https://drive.google.com/file/d/1lT8I2a0DEqRkjlL2AstSfFJ1ts_qE1C-/view?usp=drive_link",
  },
  {
    category_id: 6,
    category_en: "写真の配信方法",
    category_ja: "写真の配信方法",
    paragraph_number: "2",
    title_en: "写真の確認",
    title_ja: "写真の確認",
    url: "https://drive.google.com/file/d/1aeoR6pPSXARwAtJOqV8H_ntB0mjlqsAm/view?usp=drive_link",
  },
  {
    category_id: 6,
    category_en: "写真の配信方法",
    category_ja: "写真の配信方法",
    paragraph_number: "3",
    title_en: "写真の配信",
    title_ja: "写真の配信",
    url: "https://drive.google.com/file/d/1W6mepsRTQbBRwl9NglWlTlywPZyllIJ9/view?usp=drive_link",
  },
  {
    category_id: 6,
    category_en: "写真の配信方法",
    category_ja: "写真の配信方法",
    paragraph_number: "4",
    title_en: "配信した写真の確認",
    title_ja: "配信した写真の確認",
    url: "https://drive.google.com/file/d/1IcpeY296M5yzascWnHuNvYYk8s7SomrA/view?usp=drive_link",
  },
  {
    category_id: 7,
    category_en: "配信済写真の活用",
    category_ja: "配信済写真の活用",
    paragraph_number: "■",
    title_en: "【全文】配信済写真の活用",
    title_ja: "【全文】配信済写真の活用",
    url: "https://drive.google.com/file/d/17XEzdd3YDTDRXIVLv3zNS7KDDN6yVp2t/view?usp=drive_link",
  },
  {
    category_id: 7,
    category_en: "配信済写真の活用",
    category_ja: "配信済写真の活用",
    paragraph_number: "1",
    title_en: "月間枚数カウント",
    title_ja: "月間枚数カウント",
    url: "https://drive.google.com/file/d/1zz_MNUL98HN0821GlklLOowN4b1IKXqW/view?usp=drive_link",
  },
  {
    category_id: 7,
    category_en: "配信済写真の活用",
    category_ja: "配信済写真の活用",
    paragraph_number: "2",
    title_en: "活動タグ",
    title_ja: "活動タグ",
    url: "https://drive.google.com/file/d/1loVb0spJJtzrqsJktIgrTRrV_aPZullK/view?usp=drive_link",
  },
  {
    category_id: 7,
    category_en: "配信済写真の活用",
    category_ja: "配信済写真の活用",
    paragraph_number: "3",
    title_en: "今月のわくわく",
    title_ja: "今月のわくわく",
    url: "https://drive.google.com/file/d/1EKwHZu9bwyXrsyJg46Wp0iAvF56M6-3f/view?usp=drive_link",
  },
];
